import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import * as _ from 'lodash';
import {AuthenticationService} from '../services/authentication.service';
import {ApiService} from '../services/api.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  errorMessage: string = null;

  constructor(
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private apiService: ApiService,) {
  }

  ngOnInit() {
    localStorage.clear();
    this.activatedRoute.params.subscribe(params => {
      this.errorMessage = params.msg || null;
    });
  }

  login() {
    this.errorMessage = null;

    if (_.isNil(this.username) || _.isNil(this.password)) {
      this.errorMessage = this.translate.instant('PROFILE.LIST.COMPLETE');
      return;
    }

    this.authService.login(this.username, this.password).subscribe(
      user => {
        const token = _.get(user, 'token');

        localStorage.clear();
        localStorage.setItem('currentUser', token);
        this.authService.updateUserInfo(user);

        if (token != null) {
          const requireToChangePassword = _.get(user, 'require_to_change_password');
          if (requireToChangePassword) {
            localStorage.setItem('require_to_change_password', 'true');
            this.router.navigate(['/profile', 'password']);
          } else if (this.authService.isAccountant() || this.authService.isOperation()) {
            this.router.navigate(['/search']);
          } else {
            this.router.navigate(['']);
          }
        }

        this.sniff('LOGIN', this.username);
      },
      error => {
        this.errorMessage = this.apiService.getErrorMessage(error);
      }
    );
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'HOME',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/login/login.component.ts